import PropTypes from 'prop-types';
import LoadingButton from '@mui/lab/LoadingButton';

// Outlined grey button w. neutral border
// Used for secondary actions
// Uses LoadingButton to handle optional loading states

//  --- props ---
// - onClick: Function to handle button click (should have either onClick or href)
// - label: String to display on the button
// - key: String to use as the button's key
// - href: String to use as the button's href (optional, defaults to '')
// - loading: Boolean to indicate if the button is in a loading state (optional)
// - disabled: Boolean to indicate if the button is disabled (optional)

const SecondaryButton = ({
	onClick,
	label,
	loading = false,
	disabled = false,
	href = '',
	...rest
}) => {
	return (
		<LoadingButton
			{...rest}
			variant='outlined'
			size='small'
			onClick={onClick}
			href={href}
			target={href ? '_blank' : undefined}
			rel={href ? 'noopener noreferrer' : undefined}
			loading={loading}
			disabled={disabled || loading}
			sx={{
				fontSize: '12px',
				fontWeight: 500,
				padding: '7px 14px',
				borderRadius: '6px',
				borderColor: 'border.main',
				color: 'text.secondary',
				cursor: 'pointer',
			}}
		>
			{label}
		</LoadingButton>
	);
};

SecondaryButton.propTypes = {
	onClick: PropTypes.func,
	href: PropTypes.string,
	loading: PropTypes.bool,
	label: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
};

export default SecondaryButton;
